<h2 class="dashboard-title" *ngIf="configurations?.['dashboard-name'] && !showSummaryDynamicTitle()">
  {{ configurations["dashboard-name"] }}
</h2>

@if (configurations?.layout === 'left-filter-column') {
<div
  class="dashboard-split"
  [class.product-roadmap-page-card]="isProductRoadmapPage()"
  [class.product-roadmap-loading]="isProductRoadmapPage() && isProductRoadmapLoading"
>
  @if (isProductRoadmapPage() && isProductRoadmapLoading) {
  <output class="product-roadmap-loader" aria-live="polite" aria-busy="true">
    <div class="product-roadmap-loader-panel">
      <div class="product-roadmap-loader-spinner" aria-hidden="true"></div>
      <p class="product-roadmap-loader-text">Loading Data...</p>
    </div>
  </output>
  }

  <aside class="dashboard-sidebar">
    @if(!!configurations?.filters || !!configurations?.customFilters || !!configurations?.buttons ) {
    <div class="filter-section filters-container sidebar">
      <div class="filter-stack">
        <div class="toolbar-row toolbar-row-sidebar">
          <div class="toolbar-left">
            @if(!!configurations?.filters) {
            <app-global-filter [config]="configurations?.filters"></app-global-filter>
            } @if(!!configurations?.customFilters) {
            <app-custom-filter
              [filters]="configurations?.customFilters"
              [layout]="'column'"
            ></app-custom-filter>
            }
            <div class="reset-link-row">
              <div (click)="resetSelection()" class="info-icon reset-link">
                <mat-icon>filter_alt</mat-icon><span>Reset Filter</span>
              </div>
              @if (isProductRoadmapPage()) {
              <button
                type="button"
                class="roadmap-info-btn"
                aria-label="Product roadmap info"
                [matTooltip]="' The selections below will filter both the projects displayed on the chart and the investment numbers shown at the top of the screen.'"
                matTooltipPosition="right"
                matTooltipShowDelay="300"
              >
                <i class="fas fa-info-circle" aria-hidden="true"></i>
              </button>
              }
            </div>
          </div>
          @if (configurations?.planningYearSelector?.years?.length && configurations?.planningYearSelector?.visible !== false) {
          <div class="planning-year-selector" aria-label="Planning year selector">
            <span class="planning-year-label">
              {{ configurations?.planningYearSelector?.label || 'Select Planning Year' }}
            </span>
            <div class="planning-year-options" role="group">
              @for (year of configurations?.planningYearSelector?.years; track year) {
              <button
                type="button"
                class="planning-year-option"
                (click)="selectPlanningYear(year)"
                [class.active]="year === selectedYear"
                [attr.aria-pressed]="year === selectedYear"
              >
                {{ year }}
              </button>
              }
            </div>
          </div>
          }
        </div>
      </div>
      @if(!!configurations?.notes) {
      <div class="note">
        <strong>Notes:</strong>
        <ul style="margin: 4px 0 0 16px; padding: 0">
          <li *ngFor="let item of configurations.notes">
            {{item}}
          </li>
        </ul>
      </div>
      } @if(!!configurations?.buttons) {
      <app-button [data]="configurations?.buttons"></app-button>
      }
      <div *ngIf="configurations?.legendTable" class="legend-wrapper">
        <app-legend-table [data]="configurations.legendTable"></app-legend-table>
      </div>
    </div>
    }

    @if (configurations?.leftSidebarWidgets?.length) {
    <div class="slider-section sidebar-widgets">
      @for (widget of configurations?.leftSidebarWidgets; track $index) {
      <app-widget-renderer [charts]="widget"></app-widget-renderer>
      }
    </div>
    }
  </aside>

  <section class="dashboard-main">
    @for (item of configurations?.pageContent; track $index; let itemIndex = $index) {
    <div class="row" style="margin-bottom: 4px;">
      @if (showSummaryDynamicTitle() && item?.id === 'summaryRow') {
      <div [class]="resolveSummaryTitleClass()">
        <h2 class="dashboard-title-inline">
          {{ dynamicSummaryTitle || configurations["dashboard-name"] }}
        </h2>
      </div>
      }
      @for (column of item?.columns; track $index) {
      <div
        class="col {{
          clickedWidgetId === column?.widgetId && column.resize ? column?.onClick : column?.class
        }}"
      >
        @if (column?.type) {
        <app-widget-renderer [charts]="column"></app-widget-renderer>
        } @if (column?.rows?.length > 0) { @for (nestedItem of column.rows; track
        $index) { @if(nestedItem?.type) {
        <div
          class="col {{
            clickedWidgetId === nestedItem?.widgetId  && column.resize
              ? nestedItem?.onClick
              : nestedItem?.class
          }}"
        >
          <app-widget-renderer [charts]="nestedItem"></app-widget-renderer>
        </div>
        } @if(nestedItem?.columns?.length > 0) {
        <div class="row" style="margin-bottom: 4px;display: flex;justify-content: center;">
          <h4 class="title" *ngIf="nestedItem?.title">{{ nestedItem?.title }}</h4>
          @for (nestedCol of nestedItem.columns; track $index) {
          <div
            class="col {{
              clickedWidgetId === nestedCol?.widgetId && nestedCol.resize
                ? nestedCol?.onClick
                : nestedCol?.class
            }}"
          >
            <app-widget-renderer [charts]="nestedCol"></app-widget-renderer>
          </div>
          }
        </div>
        } } }
      </div>
      }
    </div>
    }

    @if (isProductRoadmapPage() && configurations?.footnotes?.length) {
    <div class="dashboard-footnotes">
      @for (footnote of configurations?.footnotes; track $index) {
      <p class="dashboard-footnote">{{ footnote }}</p>
      }
    </div>
    }
  </section>
</div>
} @else {
@if(!!configurations?.filters || !!configurations?.customFilters ||
!!configurations?.buttons ) {
<div class="filters-container">
  <div class="toolbar-row toolbar-row-inline">
    <div class="toolbar-left">
    @if(!!configurations?.filters) {
    <app-global-filter [config]="configurations?.filters"></app-global-filter>
    } @if(!!configurations?.customFilters) {
    <app-custom-filter [filters]="configurations?.customFilters"></app-custom-filter>
    }
    <div
      (click)="resetSelection()"
      class="info-icon reset-link reset-link-inline"
      style="display: flex; align-items: center; cursor: pointer"
    >
      <mat-icon>filter_alt</mat-icon><span>Reset Filter</span>
    </div>
    </div>
    @if (configurations?.planningYearSelector?.years?.length && configurations?.planningYearSelector?.visible !== false) {
    <div class="planning-year-selector" aria-label="Planning year selector">
      <span class="planning-year-label">
        {{ configurations?.planningYearSelector?.label || 'Select Planning Year' }}
      </span>
      <div class="planning-year-options" role="group">
        @for (year of configurations?.planningYearSelector?.years; track year) {
        <button
          type="button"
          class="planning-year-option"
          (click)="selectPlanningYear(year)"
          [class.active]="year === selectedYear"
          [attr.aria-pressed]="year === selectedYear"
        >
          {{ year }}
        </button>
        }
      </div>
    </div>
    }
  </div>
  @if(!!configurations?.notes) {
  <div class="note">
    <strong>Notes:</strong>
    <ul style="margin: 4px 0 0 16px; padding: 0">
      <li *ngFor="let item of configurations.notes">
        {{item}}
      </li>
    </ul>
  </div>
  } @if(!!configurations?.buttons) {
  <app-button [data]="configurations?.buttons"></app-button>
  }
  <div *ngIf="configurations?.legendTable" class="legend-wrapper">
    <app-legend-table [data]="configurations.legendTable"></app-legend-table>
  </div>
</div>
}

  <div>
    @for (item of configurations?.pageContent; track $index; let itemIndex = $index) {
    <div class="row" style="margin-bottom: 4px;">
      @if (showSummaryDynamicTitle() && item?.id === 'summaryRow') {
      <div [class]="resolveSummaryTitleClass()">
        <h2 class="dashboard-title-inline">
          {{ dynamicSummaryTitle || configurations["dashboard-name"] }}
        </h2>
      </div>
      }
      @for (column of item?.columns; track $index) {
      <div
        class="col {{
          clickedWidgetId === column?.widgetId && column.resize ? column?.onClick : column?.class
        }}"
      >
        @if (column?.type) {
        <app-widget-renderer [charts]="column"></app-widget-renderer>
        } @if (column?.rows?.length > 0) { @for (nestedItem of column.rows; track
        $index) { @if(nestedItem?.type) {
        <div
          class="col {{
            clickedWidgetId === nestedItem?.widgetId  && column.resize
              ? nestedItem?.onClick
              : nestedItem?.class
          }}"
        >
          <app-widget-renderer [charts]="nestedItem"></app-widget-renderer>
        </div>
        } @if(nestedItem?.columns?.length > 0) {
        <div class="row" style="margin-bottom: 4px;display: flex;justify-content: center;">
          <h4 class="title" *ngIf="nestedItem?.title">{{ nestedItem?.title }}</h4>
          @for (nestedCol of nestedItem.columns; track $index) {
          <div
            class="col {{
              clickedWidgetId === nestedCol?.widgetId && nestedCol.resize
                ? nestedCol?.onClick
                : nestedCol?.class
            }}"
          >
            <app-widget-renderer [charts]="nestedCol"></app-widget-renderer>
          </div>
          }
        </div>
        } } }
      </div>
      }
    </div>
    }
  </div>

  @if (configurations?.footnotes?.length) {
  <div class="dashboard-footnotes">
    @for (footnote of configurations?.footnotes; track $index) {
    <p class="dashboard-footnote">{{ footnote }}</p>
    }
  </div>
  }
}

<!-- @if (showImplementationNotes) {
<app-notes></app-notes>
} -->
